export default __webpack_public_path__ + "static/media/budget.73ddad8f.svg";